var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('div',[(!_vm.multiline)?_c('p',{class:{'mb-0':_vm.noMargin}},[_vm._v(_vm._s(_vm.text))]):_c('p',{class:{'mb-0':_vm.noMargin}},_vm._l((_vm.lines),function(line,index){return _c('span',{key:`line-${index}`},[_vm._v("\n      "+_vm._s(line)+"\n      "),_c('br')])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }